import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "60",
  "aria-hidden": "true",
  class: "loader",
  viewBox: "0 0 60.99 38.68"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"m2.5 25.72 28-12.62 28 12.62-28 11.88z\"></path><path d=\"m2.4 19.72 28-12.62 28 12.62-28 11.88z\"></path><path d=\"m2.5 13.72 28-12.62 28 12.62-28 11.88z\"></path><path d=\"m2.5 13.72 28-12.62 28 12.62-28 11.88z\" class=\"fall a\"></path><path d=\"m2.5 13.72 28-12.62 28 12.62-28 11.88z\" class=\"fall b\"></path><path d=\"m2.5 13.72 28-12.62 28 12.62-28 11.88z\" class=\"fall c\"></path><path d=\"m2.5 13.72 28-12.62 28 12.62-28 11.88z\" class=\"fall d\"></path>", 7)
  ]))]))
}
export default { render: render }